import React from 'react';
import { compose } from '@xo-union/react-css-modules';
import { Body1, Caption } from '@xo-union/tk-ui-typography';
import { DisplayButton } from '@xo-union/tk-ui-links';
import styles from './verticalCoverPhoto.scss';
import { ImageUpload, UploadInfo } from '../../libs/gs-component-image-upload';
import Icon from '@xo-union/tk-component-icons';

interface Props {
  coverPhotoUrl?: string;
  onEditCoverPhoto: () => void;
  onReplaceCoverPhoto: (uploadInfo: UploadInfo) => Promise<void>;
  isHorizontalLayout?: boolean;
}

const CoverPhotoItem: React.FC<Props> = ({
  coverPhotoUrl,
  isHorizontalLayout = false,
  onEditCoverPhoto,
  onReplaceCoverPhoto,
}) => {
  const layoutClass = isHorizontalLayout ? styles.horizontal : styles.vertical;
  const coverPhotoItemClass = `${styles.coverPhotoItem} ${layoutClass}`;
  return (
    <div className={coverPhotoItemClass}>
      <Caption as="h4" className={styles.blockTitle}>
        Cover photo
      </Caption>
      <div className={styles.coverPhotoContainer}>
        {coverPhotoUrl ? (
          <img
            src={coverPhotoUrl}
            className={isHorizontalLayout ? styles.horizontalLayout : styles.verticalLayout}
            alt="cover"
          />
        ) : null}
        <div className={styles.coverPhotoControls}>
          <DisplayButton
            data-testid="edit-vertical-cover-photo"
            onClick={onEditCoverPhoto}
            iconName="edit"
            classes={compose({ 'tappable-area': styles.link })}
          >
            Edit
          </DisplayButton>
          <ImageUpload onUploadEnded={onReplaceCoverPhoto}>
            <div data-testid="replace-vertical-cover-photo" className={styles.replaceButton}>
              <Icon size="sm" name="share_ios" />
              <Body1>Replace</Body1>
            </div>
          </ImageUpload>
        </div>
      </div>
      <div className={styles.divider} />
    </div>
  );
};

export default CoverPhotoItem;
